import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { AssistantIcon } from '../../../assets/AssistantIcon';
import { EntryPointSuggestedQuestions } from '../subcomponents/EntryPointSuggestedQuestions';

export const MASuggestedQuestionsEntry = () => {
  const fsEntryPointEnabled = useConfigService('fs:ma-entry-point-enabled');

  if (
    !fsEntryPointEnabled
    || !(typeof BroadcastChannel !== 'undefined')
    || !(typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS)
  ) {
    return null;
  }

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <div className="sui-flex sui-flex-col sui-p-4 sui-gap-5 sui-bg-[rgb(254,239,229)]">
      <div className="sui-flex sui-flex-row sui-items-center sui-gap-3">
        <AssistantIcon width="28px" height="32px" />
        <Typography variant="h3">
          Ask Magic Apron
        </Typography>
      </div>
      <EntryPointSuggestedQuestions />
    </div>
  );
};
